module.exports = require("memoizee");


//////////////////
// WEBPACK FOOTER
// external "memoizee"
// module id = 483
// module chunks = 0